import { parseQueryParams } from 'pricing-pages-api/utils/queryUtils';
import { useCallback, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
const filterAddOnsBySearchTerm = (addOns, searchTerm) => {
  const lowerSearchTerm = searchTerm.toLowerCase();
  return addOns.filter(addOn => addOn.titleText.toLowerCase().includes(lowerSearchTerm) || addOn.descriptionText.toLowerCase().includes(lowerSearchTerm));
};
export function useAddOnsSearch({
  validAddOns
}) {
  const history = useHistory();
  const {
    searchAddOns: addOnQueryParam
  } = parseQueryParams(history.location.search);
  const searchTermFromUrl = Array.isArray(addOnQueryParam) ? addOnQueryParam[0] : addOnQueryParam;
  const [searchTerm, setSearchTerm] = useState(searchTermFromUrl || '');
  const filteredAddOns = useMemo(() => searchTerm.trim() ? filterAddOnsBySearchTerm(validAddOns, searchTerm) : validAddOns, [validAddOns, searchTerm]);
  const updateUrlSearchParam = useCallback(term => {
    const search = term ? `?${new URLSearchParams({
      searchAddOns: term
    }).toString()}` : '';
    history.push({
      pathname: history.location.pathname,
      search
    });
  }, [history]);
  const handleSearchChange = useCallback(event => {
    const newSearchTerm = event.target.value;
    setSearchTerm(newSearchTerm);
    updateUrlSearchParam(newSearchTerm);
  }, [updateUrlSearchParam]);
  return {
    searchTerm,
    filteredAddOns,
    handleSearchChange,
    showSearchInput: validAddOns.length > 5
  };
}